module.exports = __webpack_public_path__ + "static/img/3_2_3_1.4838bed3.jpg";